module.exports = __webpack_public_path__ + "static/img/influencer.d326d626.png";